module.exports = __webpack_public_path__ + "static/media/step2-select.f0ce69f9.svg";